import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes = [
    { path: '/', redirect: '/login' },
    { path: '/login', component: () => import('@/views/Login.vue') },
    { path: '/delivery-list', component: () => import('@/views/DeliveryList.vue') },
    { path: '/packing/:id', component: () => import('@/views/Packing.vue') },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// 添加路由守卫
router.beforeEach((to, _from, next) => {
    const authStore = useAuthStore();
    const token = authStore.token;

    // 如果访问的是登录页面，并且已经登录，则重定向到主页
    if (to.path === '/login' && token) {
        next('/delivery-list');
        return;
    }

    // 如果访问的不是登录页面，但没有登录，则重定向到登录页面
    if (to.path !== '/login' && !token) {
        next('/login');
        return;
    }

    // 其他情况正常放行
    next();
});

export default router;
